<template>
  <auth-layout :title="$t('Register')">
    <template v-slot:body>
      <div class="panel-register-form-wrapper">
        <register-form
          login-href="/login"
          @success="handleSuccess"
        />
      </div>
    </template>
  </auth-layout>
</template>

<script>
import RegisterForm from '@shared/auth/RegisterForm.vue';

export default {
  components: {
    RegisterForm,
  },
  methods: {
    handleSuccess(user) {
      this.$store.dispatch('applyAuthenticatedUser', user);

      const redirectUrl = this.$route.query.redirect_url || '/user-settings/account';
      if (/^https?:\/\//.test(redirectUrl)) {
        window.location.href = redirectUrl;
        return;
      }

      this.$router.replace(redirectUrl).catch(() => {});
    },
  },
  destroyed() {
    this.$store.dispatch('clearErrors');
  },
};
</script>
